/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Language_HeaderInputs */



/**
* | output |
* | --- |
* | "Language Code" |
*
* @param {Iconik_Publish_Language_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_language_header = /** @type {((inputs?: Iconik_Publish_Language_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Language_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code langue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice della lingua")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Языковой код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de idioma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("语言代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言語コード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भाषा कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de idioma")
	return /** @type {LocalizedString} */ ("Language Code")
});